export default __webpack_public_path__ + "static/ownership-d963e4b7183b9eaca93c53a04c02946f.jpg";